var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "mt-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Préférences de paiement")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Informations de paiement")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.payment,
            callback: function($$v) {
              _vm.payment = $$v
            },
            expression: "payment"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "delay" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Afficher le délai de règlement")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "means" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher les moyens de règlements"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "deadline" } }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Afficher la date limite de règlement"))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "deposit" } }, [
                _vm._v(_vm._s(_vm.$l10n.__("Afficher le détail de l‘acompte")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.hasOnlinePayment
        ? _c(
            "div",
            [
              _c("h3", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Modules de paiement en ligne")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Choisissez les modules de paiement en ligne que vous voulez activer par défaut sur vos documents."
                      )
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.onlinePayment,
                    callback: function($$v) {
                      _vm.onlinePayment = $$v
                    },
                    expression: "onlinePayment"
                  }
                },
                _vm._l(_vm.availableOnlinePayment, function(key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "form-group" },
                    [
                      _c("el-checkbox", { attrs: { label: key } }, [
                        _vm._v(_vm._s(_vm.getLabelForOnlinePayment(key)))
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasDirectDebit
        ? _c(
            "div",
            [
              _c("h3", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Modules de prélèvement")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Choisissez le module de prélèvement automatique que vous voulez activer par défaut sur vos documents."
                      )
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.directDebit,
                    callback: function($$v) {
                      _vm.directDebit = $$v
                    },
                    expression: "directDebit"
                  }
                },
                [
                  _vm._l(_vm.availableDirectPayment, function(key) {
                    return _c(
                      "div",
                      { key: key, staticClass: "form-group" },
                      [
                        _c("el-radio", { attrs: { label: key } }, [
                          _vm._v(_vm._s(_vm.getLabelForDirectPayment(key)))
                        ])
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$l10n.__(
                          "Ne pas activer de module de prélèvements par défaut"
                        )
                      )
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }